/**
 * Generate a data URI SVG placeholder image
 * @param {number} width - Image width
 * @param {number} height - Image height
 * @param {string} text - Text to display (default: "Product")
 * @param {string} bgColor - Background color (default: "#003566" - navy blue)
 * @param {string} textColor - Text color (default: "#ffffff" - white)
 * @returns {string} Data URI SVG string
 */
export function generatePlaceholder(width = 400, height = 400, text = 'Product', bgColor = '#003566', textColor = '#ffffff') {
  // Escape special characters for XML/SVG
  const escapeXml = (str) => {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&apos;');
  };
  
  const escapedText = escapeXml(text);
  const svg = `<svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg">
  <rect width="100%" height="100%" fill="${bgColor}"/>
  <text x="50%" y="50%" font-family="Arial, sans-serif" font-size="${Math.min(width, height) / 8}" font-weight="bold" fill="${textColor}" text-anchor="middle" dominant-baseline="middle">${escapedText}</text>
</svg>`;
  
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}

/**
 * Get a placeholder image for a product
 * @param {string} productName - Product name
 * @param {number} width - Image width (default: 400)
 * @param {number} height - Image height (default: 400)
 * @returns {string} Data URI SVG string
 */
export function getProductPlaceholder(productName, width = 400, height = 400) {
  const displayName = productName || 'Product';
  // Truncate long names to fit better
  const truncatedName = displayName.length > 15 
    ? displayName.substring(0, 15) + '...' 
    : displayName;
  
  return generatePlaceholder(width, height, truncatedName, '#003566', '#ffffff');
}

/**
 * Get a simple placeholder image
 * @param {number} width - Image width (default: 400)
 * @param {number} height - Image height (default: 400)
 * @returns {string} Data URI SVG string
 */
export function getSimplePlaceholder(width = 400, height = 400) {
  return generatePlaceholder(width, height, 'Product', '#003566', '#ffffff');
}

